import { Routes, Route } from "react-router-dom";
import { useState } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";

/* MAIN PAGES */
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Clients from "./pages/Clients";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import Downloads from "./pages/Downloads";
import QualityCertificate from "./pages/QualityCertificate";

/* PRODUCT PAGES */
import TransformerOilPumps from "./pages/products/TransformerOilPumps";
import MonoblocksPumps from "./pages/products/MonoblocksPumps";
import CannedMotorPumps from "./pages/products/CannedMotorPumps";
import MarinePumps from "./pages/products/MarinePumps";
import ProcessPumps from "./pages/products/ProcessPumps";
 import CEODetails from "./components/CEODetails";

function App() {
  const [dark, setDark] = useState(true); // GLOBAL THEME

  return (
    <div className={dark ? "app dark" : "app light"}>
      {/* HEADER (Logo + Company Name is inside Header.jsx) */}
      <Header dark={dark} setDark={setDark} />

      {/* ROUTES */}
      <Routes>
        {/* MAIN ROUTES */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/downloads" element={<Downloads />} />
        <Route path="/quality-certificate" element={<QualityCertificate />} />
       

<Route path="/ceo-details" element={<CEODetails />} />

        {/* PRODUCT ROUTES */}
        <Route
          path="/products/transformer-oil-pumps"
          element={<TransformerOilPumps />}
        />
        <Route
          path="/products/monoblock-pumps"
          element={<MonoblocksPumps />}
        />
        <Route
          path="/products/canned-motor-pumps"
          element={<CannedMotorPumps />}
        />
        <Route
          path="/products/marine-pumps"
          element={<MarinePumps />}
        />
        <Route
          path="/products/process-pumps"
          element={<ProcessPumps />}
        />

        {/* 404 */}
        <Route path="*" element={<h1>Page Not Found</h1>} />
      </Routes>

      {/* FOOTER */}
      <Footer />
    </div>
  );
}

export default App;
